module.exports = __webpack_public_path__ + "static/media/money.ef8ed492.gif";